/**
 * Випадаючий список у тулбарі шапки (посилання з ACF) — відкриття по кліку.
 * Підменю основної навігації керується з CSS, без JS.
 */
(function () {
	'use strict';

	function closeAllLang() {
		document.querySelectorAll('.header-lang.is-open').forEach(function (el) {
			el.classList.remove('is-open');
			var btn = el.querySelector('.js-header-lang-toggle');
			if (btn) {
				btn.setAttribute('aria-expanded', 'false');
			}
		});
	}

	document.addEventListener('click', function (e) {
		if (!e.target.closest('.header-lang')) {
			closeAllLang();
		}
	});

	document.querySelectorAll('.js-header-lang-toggle').forEach(function (btn) {
		btn.addEventListener('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			var wrap = btn.closest('.header-lang');
			if (!wrap) {
				return;
			}
			var otherOpen = wrap.classList.contains('is-open');
			document.querySelectorAll('.header-lang.is-open').forEach(function (el) {
				el.classList.remove('is-open');
				var oBtn = el.querySelector('.js-header-lang-toggle');
				if (oBtn) {
					oBtn.setAttribute('aria-expanded', 'false');
				}
			});
			if (!otherOpen) {
				wrap.classList.add('is-open');
				btn.setAttribute('aria-expanded', 'true');
			}
		});
	});

	document.querySelectorAll('.header-lang').forEach(function (wrap) {
		var trigger = wrap.querySelector('.header-lang__trigger-img');
		wrap.querySelectorAll('.header-lang__item').forEach(function (link) {
			link.addEventListener('click', function () {
				wrap.querySelectorAll('.header-lang__item').forEach(function (item) {
					item.classList.remove('is-active');
				});
				wrap.querySelectorAll('.header-lang__item-icon-wrap').forEach(function (iconWrap) {
					iconWrap.classList.remove('is-active');
				});

				link.classList.add('is-active');
				var activeWrap = link.querySelector('.header-lang__item-icon-wrap');
				if (activeWrap) {
					activeWrap.classList.add('is-active');
				}

				var nextFlag = link.getAttribute('data-flag-url');
				if (!nextFlag && activeWrap) {
					var img = activeWrap.querySelector('img');
					if (img) {
						nextFlag = img.getAttribute('src');
					}
				}
				if (trigger && nextFlag) {
					trigger.setAttribute('src', nextFlag);
				}
			});
		});
	});

	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') {
			closeAllLang();
		}
	});
})();
